/* eslint-disable indent */
/* eslint-disable no-debugger */
// Author: Luis Booth - September 2018

import React, { Component } from 'react';

class ModifyButton extends Component {
  /* Functionality for skipping steps

  state = {
    updateNavigationResponse: {},
  }

  updateNavigation = async() => {

    const { route, stepNumber: sequenceId = 1 } = this.props;

    const updateNavigationResponse = await DataService.updateNavigation(sequenceId);

    this.setState({ updateNavigationResponse });

    if(updateNavigationResponse.code === 1) {
      window.location.href = `${route}/?subSessionId=${ window._app.page.subSessionId }`;

      return;
    }
  }

  */
  whatWording = step => (step > 1 ? 'EDIT' : 'START OVER');

  goBack = () => {
    const { step } = this.props;
    let route;

    switch(step) {
      case 1:
        route = '';
        break;
      case 2:
          route = '/room';
          break;
      case 3:
        route = '/itineraries';
        break;
      case 4:
        route = '/guests';
        break;

      default:
        route = '';
        break;
    }
    window.location.href = `${route}/?subSessionId=${ window._app.page.subSessionId }`;
  }

  render() {
    const { step } = this.props;

    const stepLabel = this.whatWording(step);

    return (
      <button
        className="modify-button"
        onClick={this.goBack}
      >
        {stepLabel}
      </button>
    );
  }
}

export default ModifyButton;

// to-do add default props
// route prop needs to be required



// WEBPACK FOOTER //
// ./js/components/global/ModifyButton.js